<template>
    <div class="view view-profile">
        <HeaderProfile />
        <ProfileOverview />
        <div class="view-profile-settings">
            <ProfileSettingsPassword />
            <ProfileSettingsEmail />
        </div>
        <BtnChallenge />
        <BtnPracticeModes />
        <Navbar />
    </div>
</template>
<script>
    // Component imports.
    import HeaderProfile        from '@/components/HeaderProfile.vue';
    import ProfileOverview      from '@/components/ProfileOverview.vue';
    import ProfileSettingsPassword from '@/components/ProfileSettingsPassword';
    import ProfileSettingsEmail from '@/components/ProfileSettingsEmail.vue';
    import BtnChallenge         from '@/components/BtnChallenge.vue';
    import BtnPracticeModes     from '@/components/BtnPracticeModes.vue';
    import Navbar               from '@/components/Navbar.vue';

    export default {
        components: {
            HeaderProfile,
            ProfileOverview,
            ProfileSettingsPassword,
            ProfileSettingsEmail,
            BtnChallenge,
            BtnPracticeModes,
            Navbar,
        },

        methods: {
            toggleFixedHeader(event){
                if(window.scrollY >= 42){
                    document.querySelector('.header-profile').classList.add('header-profile--fixed');
                }
                else{
                    document.querySelector('.header-profile').classList.remove('header-profile--fixed');
                }
            }
        },

        mounted(){
            window.addEventListener('scroll', this.toggleFixedHeader)
        },

        beforeUnmount(){
            window.removeEventListener('scroll', this.toggleFixedHeader);
        }
    };
</script>
<style scoped src="@/css/views/view-profile.css"></style>